module.exports = new __parcel__URL__("phone-icon.95df6bb3.svg").toString();